/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Generate_FailedInputs */



/**
* | output |
* | --- |
* | "That did not work. Try again, or write the report yourself." |
*
* @param {Meeting_Report_Generate_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_generate_failed = /** @type {((inputs?: Meeting_Report_Generate_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Generate_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dat lukte niet. Probeer het opnieuw of schrijf je verslag zelf.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela n'a pas fonctionné. Réessayez ou rédigez votre compte rendu vous-même.")
	return /** @type {LocalizedString} */ ("That did not work. Try again, or write the report yourself.")
});